module.exports = __webpack_public_path__ + "8cc4b7d2e0d61edbc8a53f982767e62e.pdf";